<template>
  <div>
    <b-container>
      <!--title-->
      <h1 class="title"><strong>مقالات</strong></h1>
      <!--list-->
      <div class="list parentLoading">
        <Loading :class="{ loading1: true ? loading1 : false }" />
        <div class="listItem" v-for="(article, index) in articles" :key="index">
          <b-row v-if="article"  @click="goTodetail(article.Id)">
            <b-col class="col-4">
              <img :src="myBaseUrl + article.ImagePath" />
            </b-col>
            <b-col class="col-8">
              <div class="hr">
                <strong>{{ article.Title }}</strong>
                <div class="dateTime">{{ article.CreatedDate }}</div>
              </div>
              <p>{{ article.Abstract }}</p>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "./Loading";

export default {
  data() {
    return {
      categories: null,
      articles: null,
      loading1: false,
    };
  },
  methods:{
        goTodetail(articleId) { 
           console.log(this.$router);
            this.$router.push({path:'/ArticleDetails/'+articleId});                       
        }
  },
  components: {
    Loading,
  },
  async created() {
    try {
      if (this.articles == null) {
        this.loading1 = true;
      }
      await axios.get("/Posts/GetArticles?count=300")
        .then((res) => {
          this.articles = res.data;
          this.loading1 = false;
        })
        .catch((err) => {
          console.log(err);
        });



    } catch (err) {
      console.log(err);
    }
    
  },
};
</script>

<style scoped>
.loading1 {
  display: block;
}
.title {
  margin-bottom: 35px;
}
ul li {
  list-style: none;
}
img {
  width: 100%;
  height: 314px;
}
.list:after,
.listItem:after,
.hr::after {
  content: "";
  clear: both;
  display: table;
}
.listItem {
  text-align: right;
  margin-bottom: 25px;
}
.listItem img {
  border-radius: 35px;
  -webkit-box-shadow: 0px 7px 15px 0px rgba(33, 33, 33, 0.15);
  -moz-box-shadow: 0px 7px 15px 0px rgba(33, 33, 33, 0.15);
  box-shadow: 0px 7px 15px 0px rgba(33, 33, 33, 0.15);
}
.listItem strong {
  color: #424242;
  font-weight: normal;
  font-size: 15pt;
  float: right;
  width: 60%;
}
.dateTime {
  text-align: left;
  font-size: 10pt;
  color: #424242;
  float: left;
  width: 40%;
  line-height: 2.1;
}
.hr {
  border-bottom: 1px solid #6a1b9a;
  padding-bottom: 5px;
  margin-bottom: 15px;
}
ul {
  padding: 0;
}
ul li {
  padding: 5px 10px;
  color: #424242;
  font-size: 12pt;
}
ul li:nth-child(odd) {
  background: #ffe0b2;
}
li span {
  margin-left: 10px;
}
@media all and (max-width: 1080px) {
  img {
    height: 288px;
  }
}
@media all and (max-width: 992px) {
  img {
    height: 216px;
  }
  .listItem strong {
    font-size: 12pt;
  }
  ul li {
    padding: 2px 10px;
    font-size: 11pt;
  }
}
@media all and (max-width: 768px) {
  img {
    height: auto;
  }
}
@media all and (max-width: 576px) {
  .listItem {
    margin-bottom: 5px;
  }
  .listItem img {
    border-radius: 15px;
  }
  img {
    margin-bottom: 15px;
  }
  .col-8 {
    padding-right: 0;
  }
  .listItem strong {
    font-size: 7pt;
  }
  .dateTime {
    font-size: 6.5pt;
    line-height: 2;
  }
  p {
    font-size: 6pt;
    margin-bottom: 5px;
  }
  .hr {
    margin-bottom: 5px;
  }

  .title {
    margin-bottom: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Articles.vue